<template>
    <div class="home w-full section-wrapper text-base mb-16 mt-12">
        <div class="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-start mb-10">
            <div>
                <div class="lg:sticky lg:top-0">
                    <div class="panel min-h-48 border">
                        <Link href="/shows" class="header-class header-link"><vue-feather type="music" size="20px" class="-mb-[2px]" aria-hidden="true" /> Next Show</Link>
                        <ShowObject v-if="nextShow" class="block w-full" :show="nextShow" />
                        <div v-else class="w-full h-28 flex flex-wrap justify-center items-center text-center">
                            No Upcoming Show. Check Back Soon!
                        </div>
                    </div>
                    <div class="panel">
                        <Standings gender="men" :standings="standingsMen" />
                        <Standings gender="women" :standings="standingsWomen" />

                    </div>
                    <div class="panel">
                        <Link class="header-class header-link" href="/photos">
                            <vue-feather type="image" size="20px" class="-mb-[2px] mr-1" aria-hidden="true" />
                            Latest Photos
                        </Link>
                        <HomeLatestPhotos :photos="latestPhotos" :count="15" />
                    </div>
                </div>
            </div>
            <div>
                <div class="panel">
                    <Link class="header-class header-link" href="/birds"><vue-feather type="twitter" size="20px" class="-mb-[2px] mr-1" aria-hidden="true" /> Today's Visiting Birds</Link>
                    <BirdsLatest :trigger="trigger"/>
                </div>
                <div class="panel">
                    <Link class="header-class header-link" href="/music">
                        <vue-feather type="disc" size="20px" class="-mb-[2px] mr-1" aria-hidden="true" />
                        Upcoming Albums
                    </Link>
                    <HomeUpcomingAlbums :albums="upcomingAlbums" :count="5" />
                </div>
                <div class="panel">
                    <Link class="header-class header-link" href="/recipes">
                        <vue-feather type="coffee" size="20px" class="-mb-[2px] mr-1" aria-hidden="true" />
                        Latest Recipes
                    </Link>
                    <HomeLatestRecipes :recipes="latestRecipes" :count="5" />
                </div>
            </div>
            <div>
                <div class="panel">
                    <Link class="header-class header-link" href="/television">
                        <vue-feather type="tv" size="20px" class="-mb-[2px]" aria-hidden="true" />
                        Upcoming TV Shows
                    </Link>
                    <TelevisionUpcomingShows class="mt-4" :count="4" :shows="tv" :assetsPath="assetsPath"  />
                </div>
                <div class="panel">
                    <Link class="header-class header-link" href="/movies">
                        <vue-feather type="film" size="20px" class="-mb-[2px] mr-1" aria-hidden="true" />
                        Upcoming Movies
                    </Link>
                    <HomeUpcomingMovies :movies="upcomingMovies" :count="5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BirdsLatest from '@/Components/BirdsLatest.vue';
import HomeLatestPhotos from '@/Components/HomeLatestPhotos.vue';
import HomeLatestRecipes from '@/Components/HomeLatestRecipes.vue';
import HomeUpcomingAlbums from '@/Components/HomeUpcomingAlbums.vue';
import HomeUpcomingMovies from '@/Components/HomeUpcomingMovies.vue';
import TelevisionUpcomingShows from '@/Components/TelevisionUpcomingShows.vue';
import GuestLayout from '../Layouts/GuestLayout.vue';
import ShowObject from '@/Components/ShowObject.vue';
import { Link } from '@inertiajs/vue3'
import { urlify } from '@/utils/Utilities';
import { gsap } from "gsap/all";
import { mapWritableState } from 'pinia';
import { useGeneralStore } from '@/utils/useGeneralStore';
import BasketballStandings from '@/Components/BasketballStandings.vue';
import pageTransitionMixin from '@/utils/pageTransitionMixin';
import * as DataService from '../DataService.js'

    export default {
        layout: GuestLayout,
        name: "HomeBar",
        mixins: [pageTransitionMixin],
        components: { BirdsLatest, HomeLatestPhotos, HomeLatestRecipes, HomeUpcomingAlbums, HomeUpcomingMovies, Link, ShowObject, TelevisionUpcomingShows, Standings: BasketballStandings },
        computed: {
            ...mapWritableState(useGeneralStore, ['latestBirds'])
        },
        props: ['foo', 'tv', 'birds', 'shows', 'standingsMen', 'standingsWomen', 'assetsPath', 'upcomingAlbums', 'upcomingMovies', 'latestPhotos', 'latestRecipes'],
        data() {
            return {
                nextShow: null,
                trigger: false
            }
        },
        unmounted() {
            this.trigger=false;
        },
        mounted() {
            this.nextShow=this.shows[0];
            gsap.fromTo('.panel', {scale: 0}, {scale: 1, stagger: .02, duration: .2, onComplete: () => {
                this.trigger=true;
            }})
            this.latestBirds=this.birds;

        },
        methods: {
            urlify,
            exitAnim() {
                return gsap.to('.panel', {
                    scale: 0,
                    stagger: { each: .02, from: 'end' },
                    duration: .2,
                });
            }
        }
    }
</script>

<style lang="postcss">
.panel {
    border: 1px solid rgba(100,100,100,.3);
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    background-color: rgba(100,100,100,.1);
}
</style>
